const useRj = () => {
  const drawerMenu = [];

  return {
    drawerMenu,
  };
};

export default useRj;
